export interface ICounterOfferResponse {
  readonly status: CounterOfferResponseStatusEnum;
}

export enum CounterOfferResponseStatusEnum {
  Active = 'active',
  Declined = 'declined',
  Withdrawn = 'withdrawn',
  Expired = 'expired',
  Applied = 'applied',
}
